// HomePage component - Converted from pages/index.vue
// Main home page with all sections
import React from 'react';
import AboutOne from '../components/AboutOne';
import ServiceOne from '../components/ServiceOne';
import Benefits from '../components/Benefits';
import ProductOne from '../components/ProductOne';
import Footer from '../components/Footer';
import RecentProjectThree from '../../components/RecentProjectThree.jsx';
import HeaderThree from '../../components/HeaderThree.jsx';
import CallToActionThree from '../../components/CallToActionThree.jsx';
import HealthyFood from '../../components/HealthyFood.jsx';
import WhyChooseOne from '../../components/WhyChooseOne.jsx';

const HomePage: React.FC = () => {
  // Set page title - converted from Vue useHead

  return (
    <div>
      <HeaderThree  />

      <AboutOne />
      <ServiceOne />
      {/* <BrandOne />
      <FeaturedOne /> */}
     {/* <VideoOne /> */}
      {/* <TestimonialOne /> */}
      {/* <RecentProject /> */}
            <RecentProjectThree /> 
              <HealthyFood />
              <WhyChooseOne />
      <Benefits  />
     <ProductOne />
      {/*   <BlogOne /> */}
      <CallToActionThree />
      <Footer />
    </div>
  );
};

export default HomePage;
